import { render } from "./PageSelector.vue?vue&type=template&id=692dc02c&scoped=true"
import script from "./PageSelector.vue?vue&type=script&lang=js"
export * from "./PageSelector.vue?vue&type=script&lang=js"

import "./PageSelector.vue?vue&type=style&index=0&id=692dc02c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692dc02c"]])

export default __exports__